export type AgentActivityState =
  | 'thinking'
  | 'working'
  | 'awaiting'
  | 'completed';

/** Runtime facts only: authored and translated labels never select a face. */
export function resolvePendingAgentActivity({
  hasRunningToolCall,
  callbackWaitLabel,
}: {
  hasRunningToolCall: boolean;
  callbackWaitLabel: string | null;
}): AgentActivityState {
  return hasRunningToolCall || callbackWaitLabel !== null
    ? 'working'
    : 'thinking';
}

export function shouldAnimateAgentActivity({
  state,
  animate,
  reducedMotion,
  inView,
  pageVisible,
}: {
  state: AgentActivityState;
  animate: boolean;
  reducedMotion: boolean;
  inView: boolean;
  pageVisible: boolean;
}): boolean {
  return (
    (state === 'thinking' || state === 'working') &&
    animate &&
    !reducedMotion &&
    inView &&
    pageVisible
  );
}
